import { Grid, useTheme } from "@mui/material";

import { DotSelector } from "./DotSelector/DotSelector";

import { DashboardIconButton } from "@/dashboard-design-system/IconButton";
import { ChevronLeft, ChevronRight } from "@/icons/outlined";

interface BottomSelectorProps {
  photoUrls: string[];
  displayedImageIndex: number;
  setSelectedIndex: (index: number) => void;
  goLeft: () => void;
  goRight: () => void;
  size: "small" | "medium" | "large";
  noArrows?: boolean;
}

export const BottomSelector = ({
  photoUrls,
  displayedImageIndex,
  setSelectedIndex,
  goLeft,
  goRight,
  size,
  noArrows,
}: BottomSelectorProps) => {
  const theme = useTheme();
  return (
    <Grid container justifyContent="space-between" alignItems="center">
      {!noArrows && (
        <Grid item>
          <DashboardIconButton
            size="small"
            disabled={displayedImageIndex === 0}
            onClick={goLeft}
            sx={{
              "& svg": {
                fill: theme.palette.text.form.quiet,
              },
            }}
          >
            <ChevronLeft />
          </DashboardIconButton>
        </Grid>
      )}
      <Grid item xs>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          spacing={size === "large" ? 4 : size === "medium" ? 2 : 1}
        >
          {photoUrls.map((photoUrl, index) => (
            <Grid item key={index + photoUrl}>
              <DotSelector
                isSelected={displayedImageIndex === index}
                index={index}
                setSelectedIndex={setSelectedIndex}
                size={size}
              />
            </Grid>
          ))}
        </Grid>
      </Grid>
      {!noArrows && (
        <Grid item>
          <DashboardIconButton
            size="small"
            disabled={displayedImageIndex + 1 >= photoUrls.length}
            onClick={goRight}
            sx={{
              "& svg": {
                fill: theme.palette.text.form.quiet,
              },
            }}
          >
            <ChevronRight />
          </DashboardIconButton>
        </Grid>
      )}
    </Grid>
  );
};
